const alignAndEngageRoutes = {
  AlignAndEngage: () => `/w/okrs/all`,
  AlignAndEngageOverview: () => `/w/okrs/all`,
};

const routes = { ...alignAndEngageRoutes };

export default routes;
